"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Studio = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const Studio = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.72303 1C9.96432 1 10.1599 1.19495 10.1599 1.43544V4.42258C10.1599 4.66307 9.96432 4.85802 9.72303 4.85802C9.48174 4.85802 9.28613 4.66307 9.28613 4.42258V1.43544C9.28613 1.19495 9.48174 1 9.72303 1Z",
      fill: "#383745"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.72303 10.8489C9.96432 10.8489 10.1599 11.0439 10.1599 11.2844V16.649C10.1599 16.8895 9.96432 17.0845 9.72303 17.0845C9.48174 17.0845 9.28613 16.8895 9.28613 16.649V11.2844C9.28613 11.0439 9.48174 10.8489 9.72303 10.8489Z",
      fill: "#383745"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.6557 10.7418C12.8917 10.6919 13.1237 10.8422 13.1737 11.0775L14.7465 18.4713C14.7966 18.7065 14.6458 18.9377 14.4097 18.9876C14.1737 19.0374 13.9418 18.8872 13.8917 18.6519L12.3189 11.2581C12.2689 11.0228 12.4197 10.7917 12.6557 10.7418Z",
      fill: "#383745"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.9536 1.40763C11.1898 1.35871 11.4211 1.50994 11.4702 1.7454L11.9857 4.21871C12.0348 4.45417 11.8831 4.68471 11.6469 4.73362C11.4106 4.78254 11.1793 4.63131 11.1302 4.39585L10.6147 1.92254C10.5656 1.68708 10.7173 1.45654 10.9536 1.40763Z",
      fill: "#383745"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.45024 10.9156C6.68806 10.9562 6.84784 11.1813 6.8071 11.4183L5.56632 18.638C5.52558 18.875 5.29976 19.0343 5.06193 18.9937C4.82411 18.953 4.66434 18.728 4.70507 18.4909L5.94585 11.2713C5.98659 11.0343 6.21241 10.875 6.45024 10.9156Z",
      fill: "#383745"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.52984 1.41462C8.76223 1.47934 8.89797 1.71958 8.83302 1.95119L8.10778 4.53772C8.04283 4.76934 7.8018 4.90462 7.56942 4.8399C7.33703 4.77517 7.20129 4.53494 7.26623 4.30332L7.99148 1.71679C8.05642 1.48518 8.29745 1.34989 8.52984 1.41462Z",
      fill: "#383745"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.48511 14.8988C5.48511 14.6583 5.68071 14.4633 5.922 14.4633H13.5327C13.774 14.4633 13.9696 14.6583 13.9696 14.8988C13.9696 15.1392 13.774 15.3342 13.5327 15.3342H5.922C5.68071 15.3342 5.48511 15.1392 5.48511 14.8988Z",
      fill: "#383745"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.50708 5.17094C5.36602 5.17094 5.29737 5.26516 5.29737 5.33779V10.9107C5.29737 11.1411 5.10177 11.3278 4.86048 11.3278C4.61919 11.3278 4.42358 11.1411 4.42358 10.9107V5.33779C4.42358 4.7597 4.93164 4.33667 5.50708 4.33667H13.9391C14.5146 4.33667 15.0226 4.7597 15.0226 5.33779V10.8523C15.0226 11.0827 14.827 11.2694 14.5857 11.2694C14.3445 11.2694 14.1489 11.0827 14.1489 10.8523V5.33779C14.1489 5.26516 14.0802 5.17094 13.9391 5.17094H5.50708Z",
      fill: "#5750FA"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 11.1677C4 10.9272 4.1956 10.7322 4.43689 10.7322H15.0185C15.2598 10.7322 15.4554 10.9272 15.4554 11.1677C15.4554 11.4082 15.2598 11.6031 15.0185 11.6031H4.43689C4.1956 11.6031 4 11.4082 4 11.1677Z",
      fill: "#5750FA"
    })]
  });
};
exports.Studio = Studio;